/**
 * Created by bartdecorte on 27/04/2017.
 */
import CsvMapModal from '../../modals/CsvMapModal';
import AssetImportModal from '../../modals/AssetImportModal';
import Request from '../../utils/Request';
import {endpoints} from '../../utils/api';
import {modifierState} from '../../helpers/os';
import IndexPage from '../IndexPage';
import CsvImportModal from '../../modals/CsvImportModal';

class TablesShow extends IndexPage {
  constructor(params) {
    super(params);
    this.$root = params.$root;
    this.$lastChecked = undefined;
    this.shiftDown = false;
    this.csvMapModal = new CsvMapModal();
    if (document.querySelector('#modal-asset')) {
      this.assetImportModal = new AssetImportModal();
    }
    this.csvImportModal = new CsvImportModal();
    this.timeouts = {};
    this.columnUpdateDelay = 1000; // ms
    this.sortQueue = [];
    this.bindKeys(this.keyBindings());
  }

  bindListeners() {
    super.bindListeners();
    $('.entries')
      .find('.btn-edit, .btn-clone, .btn-delete, .switchery')
      .on('click', (ev) => this.lStopPropagation(ev));
    $('.js-entry-select-all').on('change', (ev) =>
      this.lEntrySelectAllChanged(ev)
    );
    $('.js-entry-select').on('change', (ev) => this.lEntrySelectChanged(ev));
    $(document).on('keydown keyup', (ev) => this.lKeyPressed(ev));
    $('.js-delete-selected').on('click', (ev) =>
      this.lDeleteSelectedClicked(ev)
    );
    $('.js-delete-all').on('click', (ev) => this.lDeleteAllClicked(ev));
    $('.js-list-alert-close').on('click', (ev) => this.manageDeleteAlert(ev));
  }

  lStopPropagation(ev) {
    ev.stopPropagation();
  }

  lRowClick(ev) {
    const cancel = ['input', 'select', 'textarea', 'a'];
    if (
      $(ev.target).is(cancel.join(', ')) ||
      $(ev.target).parents(cancel.join(', ')).length
    ) {
      return true;
    }

    const $elt =
      $(ev.target).get(0).tagName === 'TR'
        ? $(ev.target)
        : $(ev.target)
            .parents('tr')
            .first();
    $elt.find('.btn-edit').get(0);
    const $btn = $elt.find('.btn-edit');
    const location = $btn.attr('href');

    if (modifierState(ev)) {
      window.open(location, '_blank');
      return false;
    }

    window.location = location;
    return false;
  }

  lEntrySelectAllChanged(ev) {
    ev.preventDefault();
    let state = $(ev.target).is(':checked');
    $('.js-entry-select').prop('checked', state);
    this.countSelected();
    return false;
  }

  lEntrySelectChanged(ev) {
    let $current = $(ev.target);

    if (this.shiftDown) {
      if (this.$lastChecked) {
        let between = () => {
          let items = $('.js-entry-select').toArray();
          return items.filter((item) => {
            let $item = $(item);
            let $itemRow = $item.parents('tr').first();
            let $rows = $itemRow.parent().children('tr');
            let itemIndex = $rows.index($item.parents('tr').first());
            let firstIndex = $rows.index(
              this.$lastChecked.parents('tr').first()
            );
            let lastIndex = $rows.index($current.parents('tr').first());
            let minIndex = Math.min(firstIndex, lastIndex);
            let maxIndex = Math.max(firstIndex, lastIndex);
            return itemIndex > minIndex && itemIndex < maxIndex;
          });
        };
        if ($current.is(':checked') && this.$lastChecked.is(':checked')) {
          between().forEach((item) => $(item).prop('checked', true));
        } else if (
          !$current.is(':checked') &&
          !this.$lastChecked.is(':checked')
        ) {
          between().forEach((item) => $(item).prop('checked', false));
        }
      }
    } else {
      this.$lastChecked = $current;
    }

    this.countSelected();
  }

  lKeyPressed(ev) {
    if (ev.key === 'Shift') {
      if (ev.type === 'keydown') {
        this.shiftDown = true;
      } else if (ev.type === 'keyup') {
        this.shiftDown = false;
      }
    }
    return true;
  }

  lDeleteSelectedClicked(ev) {
    ev.preventDefault();
    let $form = $('.js-entry-form');
    let $action = $form.find('[name="action"]').first();
    $action.val($action.data('value-selected'));
    $form.submit();
    return false;
  }

  lDeleteAllClicked(ev) {
    ev.preventDefault();
    let $form = $('.js-entry-form');
    let $action = $form.find('[name="action"]').first();
    $action.val($action.data('value-all'));
    $form.submit();
    return false;
  }

  updateSortEndpoint() {
    let segments = endpoints.appendTraceSegments([
      'websites',
      esign.info.websiteId,
      'tables',
    ]);
    segments.push('sort');
    return segments.join('/');
  }

  updateSort(from, to) {
    this.pushSortQueue(
      this.updateSortCallback(from, to)
    ).handleNextOfSortQueue();
  }

  updateSortCallback(from, to) {
    return (x) => {
      this.setSortState('pending');
      return this.propagateUpdatedSort(from, to)
        .then((x) => {
          this.setSortState('success');
        })
        .then((x) => {
          this.handleNextOfSortQueue();
        })
        .catch((x) => {
          this.setSortState('fail').unshiftSortQueue(
            this.updateSortCallback(from, to)
          );
        });
    };
  }

  unshiftSortQueue(first) {
    this.sortQueue.unshift(first);
    return this;
  }

  pushSortQueue(next) {
    this.sortQueue.push(next);
    return this;
  }

  handleNextOfSortQueue() {
    const next = this.sortQueue.shift();
    if (typeof next !== typeof undefined) return next();

    return;
  }

  propagateUpdatedSort(from, to) {
    from += 1;
    to += 1;
    const data = {
      from,
      to,
    };
    const request = new Request(this.updateSortEndpoint(), 'PATCH', data);
    return request.execute();
  }

  setSortState(state) {
    // state: pending, success, fail, <undefined>
    const $container = $('.js-loader-states--sort');
    $container
      .find('.js-state.d-flex')
      .removeClass('d-flex')
      .addClass('d-none');
    if (typeof state !== typeof undefined) {
      $container
        .find('.js-state--' + state)
        .removeClass('d-none')
        .addClass('d-flex');
    }

    return this;
  }

  cancelScheduledColumnUpdate(entryId, columnId) {
    if (
      this.timeouts.hasOwnProperty(entryId) &&
      this.timeouts[entryId].hasOwnProperty(columnId)
    ) {
      clearTimeout(this.timeouts[entryId][columnId]);
      delete this.timeouts[entryId][columnId];

      if (Object.keys(this.timeouts[entryId]).length == 0)
        delete this.timeouts[entryId];
    }

    return this;
  }

  scheduleColumnUpdate(entryId, columnId, value, delay) {
    if (!this.timeouts.hasOwnProperty(entryId)) this.timeouts[entryId] = {};

    this.timeouts[entryId][columnId] = setTimeout(
      () => this.updateColumn(entryId, columnId, value),
      delay
    );
    return this;
  }

  updateColumn(entryId, columnId, value) {
    const $row = $('[data-entry-id="' + entryId + '"]');
    const $cell = $row.find('[data-column-id="' + columnId + '"]');
    this.setEditableCellState($cell, 'pending');
    this.propagateColumnValue(entryId, columnId, value)
      .then((x) => {
        this.setEditableCellState($cell, 'success');
      })
      .catch((x) => {
        this.setEditableCellState($cell, 'fail');
      });
  }

  propagateColumnValue(entryId, columnId, columnValue) {
    const data = {
      columns: {},
    };
    data.columns[columnId] = { value: columnValue };
    const request = new Request(
      this.updateColumnEndpoint(entryId),
      'PATCH',
      data
    );
    return request.execute();
  }

  setEditableCellState($tdElement, state) {
    // state: pending, success, fail, <undefined>
    $tdElement.find('.js-state').css('display', 'none');
    if (typeof state !== typeof undefined)
      $tdElement.find('.js-state--' + state).removeAttr('style');

    return this;
  }

  adjustForDescendingSort(from, to) {
    if (!this.isDescendingSort()) {
      return { from, to };
    }

    return {
      from: this.entryCount() - 1 - from,
      to: this.entryCount() - 1 - to,
    };
  }

  countSelected() {
    let checkboxes = document
      .querySelectorAll('.js-entry-select:checked')
      .length.toString();
    const alert = document.querySelector('.js-delete-alert');
    const sum = document.querySelector('.js-list-alert-count');

    if (checkboxes > 0) {
      alert.style.display = 'block';
    } else {
      alert.style.display = 'none';
    }

    sum.textContent = checkboxes;
  }

  manageDeleteAlert(ev) {
    const alert = document.querySelector('.js-delete-alert');
    const selectAll = document.querySelector('.js-entry-select-all');
    const selects = document.querySelectorAll('.js-entry-select');

    selectAll.checked = false;
    selects.forEach((select) => (select.checked = false));
    this.countSelected();
    alert.style.display = 'none';
  }
}

export default TablesShow;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Tables/TablesShow.js